<template>
  <el-dialog title="修改会员等级" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item label="会员名称" prop="levelName" required>
        <el-input v-model="formData.levelName" placeholder="必填，请填写会员名称" clearable />
      </el-form-item>
      <el-form-item label="会员等级" prop="vipLevel" required>
        <el-select v-model="formData.vipLevel" placeholder="必填，请选择会员等级" style="width:100%" clearable>
          <el-option v-for="item in vipLevels" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
        </el-select>
      </el-form-item>
      <el-form-item label="说明" prop="remark">
        <el-input v-model="formData.remark" type="textarea" placeholder="选填，请填写说明" :rows="3" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { updateShopVipLevel } from '@/api/user/shopVipLevelApi'

export default {
  name: 'EditShopVipLevel',
  data() {
    return {
      dialogVisible: false,
      formData: {
        vipLevelId: '',
        levelName: '',
        vipLevel: '',
        remark: '',
        goldCostMoney: '1',
        integralCostMoney: '1',
        couponValues: []
      },
      vipLevels: []
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.formData = { ...data }
      this.getVipLevelDict()
    },
    async getVipLevelDict() {
      try {
        const { data } = await getDict('s_shop_vip_level', 'vip_level')
        this.vipLevels = data
      } catch (error) {
        console.error(error)
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.formData = {
        vipLevelId: '',
        levelName: '',
        vipLevel: '',
        remark: '',
        goldCostMoney: '1',
        integralCostMoney: '1',
        couponValues: []
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        const res = await updateShopVipLevel(this.formData)
        console.log(res)
        this.$message.success('修改成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>